function vicReferralForm() {
  const $form = $('.contact-form');
  const url = new URL(window.location.href);

  if ($form.length > 0 && url.searchParams.get('tfa_next')) {
    $('html, body').animate(
      {
        scrollTop: $form.eq(0).offset().top - 200,
      },
      500,
    );

    // Set focus for keyboard + AT users
    $form.trigger('click');
  }
}

export function init() {
  vicReferralForm();
}
